import ReactDOM from "react-dom";
import AppRoutes from "./routes";

ReactDOM.render(<AppRoutes />, document.getElementById("root"));
